import { AttendancePage } from "@/pages/AttendancePage";
import { registerText } from "@/lib/register-copy";
import { PART_FOCUS, usePartHeading } from "./course-part";

/**
 * A learner's own attendance, a part of Grades (#1393 R1), addressed by
 * `?view=grades&part=attendance`. It renders its own read, so it stands when
 * no result is available.
 */
export function GradesAttendancePart({ courseId }: { courseId: string }) {
  const heading = usePartHeading("attendance");
  const id = `grades-attendance-${courseId}`;
  return <section aria-labelledby={id} className="grid gap-3 pt-6" data-part="attendance">
    <h2 id={id} ref={heading} className={`text-section font-semibold ${PART_FOCUS}`}>{registerText.attendance2}</h2>
    <AttendancePage key={courseId} workspace="learning" courseId={courseId} embedded />
  </section>;
}

/**
 * A teacher's roster and roll, the attendance part of People (#1393 R1),
 * addressed by `?view=people&part=attendance`. The roster and roll carry their
 * own Bento heads, so the arrival focuses the part itself, ahead of them.
 */
export function TeachingAttendancePart({ courseId }: { courseId: string }) {
  const part = usePartHeading<HTMLElement>("attendance");
  return <section ref={part} aria-label={registerText.attendance2} className={`grid min-w-0 ${PART_FOCUS}`} data-part="attendance">
    <AttendancePage key={courseId} workspace="teaching" courseId={courseId} embedded />
  </section>;
}
